import { session } from "../utils/session";

export let menu = [
  {
    name: "",
    path: "/",
    redirect: "Home",
    hidden: false,
    alwaysShow: false,
    meta: { title: "首页", icon: "el-icon-s-home" },
    children: [
      {
        hidden: false,
        meta: { title: "首页", icon: "user" },
        name: "Home",
        path: "Home"
      }
    ]
  },
  {
    name: "financialManagement",
    path: "/financialManagement",
    hidden: false,
    alwaysShow: true,
    meta: { title: "财务管理", icon: "el-icon-tickets" },
    component: "Layout",
    children: [
      {
        hidden: false,
        meta: { title: "期初", noCache: false},
        name: "FinanceManager",
        path: "financeManager"
      },
    ]
  },
  {
    name: "basics",
    path: "/basics",
    hidden: false,
    alwaysShow: true,
    meta: { title: "基础设置", icon: "el-icon-setting", noCache: false },
    component: "Layout",
    children: [
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "基础管理",  noCache: false },
        name: "basics",
        path: "basics",
        children: [
          {
            component: "views/BaseSettings/DictionarySettings.vue",
            hidden: false,
            meta: { title: "数据字典", noCache: false },
            name: "dictionarySettings",
            path: "dictionarySettings"
          },
          {
            component: "views/BaseSettings/UnitSettings.vue",
            hidden: false,
            meta: { title: "单位列表", noCache: false },
            name: "unitSettings",
            path: "unitSettings"
          },
          {
            hidden: false,
            meta: { title: "组织架构",  noCache: false },
            name: "orgStructureSettings",
            path: "orgStructureSettings"
          },
        ]
      },
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "权限管理",  noCache: false },
        name: "account",
        path: "account",
        children: [
          {
            hidden: false,
            meta: { title: "账号管理",  noCache: false },
            name: "accuntSettings",
            path: "accuntSettings"
          },
          {
            hidden: false,
            meta: { title: "角色管理", noCache: false },
            name: "roleSettings",
            path: "roleSettings"
          },
          {
            hidden: false,
            meta: { title: "设置审核",  noCache: false },
            name: "auditSettings",
            path: "auditSettings"
          },
        ]
      },
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "商品管理",  noCache: false },
        name: "product",
        path: "product",
        children: [
          {
            hidden: false,
            meta: { title: "打印商品码", noCache: false },
            name: "productCode",
            path: "productCode"
          },
          {
            hidden: false,
            meta: { title: "商品列表",  noCache: false },
            name: "productList",
            path: "productList"
          },
          {
            hidden: false,
            meta: { title: "商品品牌",noCache: false },
            name: "productBrand",
            path: "productBrand"
          },
          {
            hidden: false,
            meta: { title: "商品属性", noCache: false },
            name: "productProperty",
            path: "productProperty"
          },
        ]
      },
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "供应商管理", noCache: false },
        name: "supplier",
        path: "supplier",
        children: [
          {
            hidden: false,
            meta: { title: "供应商列表", noCache: false },
            name: "supplierList",
            path: "supplierList"
          }
        ]
      },
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "客户管理", noCache: false },
        name: "customer",
        path: "customer",
        children: [
          {
            hidden: false,
            meta: { title: "客户列表", noCache: false },
            name: "customerList",
            path: "customerList"
          }
        ]
      },
      {
        hidden: false,
        alwaysShow: true,
        meta: { title: "仓库管理", noCache: false },
        name: "warehouse",
        path: "warehouse",
        children: [
          {
            hidden: false,
            meta: { title: "库存统计",noCache: false },
            name: "storeStatic",
            path: "storeStatic"
          }
        ]
      },
    ]
  },
  {
    name: "meterReading",
    path: "/meterReading",
    hidden: false,
    alwaysShow: true,
    meta: { title: "租赁管理", icon: "el-icon-printer", noCache: false },
    component: "Layout",
    children: [
      {
        hidden: false,
        meta: { title: "租赁列表", noCache: false },
        name: "meterReading",
        path: "meterReading"
      },
    ]
  },
  {
    name: "platform",
    path: "/platform",
    hidden: false,
    alwaysShow: true,
    meta: { title: "平台管理", icon: "el-icon-menu", noCache: false },
    component: "Layout",
    children: [
      {
        hidden: false,
        meta: { title: "注册审核",noCache: false },
        name: "registerList",
        path: "registerList"
      },
      {
        hidden: false,
        meta: { title: "申请试用",noCache: false },
        name: "ApplyTrial",
        path: "applyTrial"
      },
      {
        hidden: false,
        meta: { title: "菜单维护",noCache: false },
        name: "MenuList",
        path: "menuList"
      },
    ]
  },
  {
    name: "Repair",
    path: "/repair",
    hidden: false,
    alwaysShow: true,
    meta: { title: "维修管理", icon: "el-icon-menu", noCache: false },
    component: "Layout",
    children: [
      {
        hidden: false,
        meta: { title: "返修换机管理",noCache: false },
        name: "RepairManagement",
        path: "repairManagement"
      }
    ]
  },
  { path: '*', name: "404",redirect: '/404', hidden: true, meta: { title: "404",noCache: false } }


];



// WEBPACK FOOTER //
// ./src/utils/routeMenu.js